import * as t from "io-ts";
import PrettyPrintIoTsErrors from "../../io-ts/PrettyPrintIoTsErrors";
import crypto from "crypto";

const saltLength = 16;

interface SaltBrand {
  readonly Salt: unique symbol;
}

export const Salt = t.brand(
  t.string,
  (n): n is t.Branded<string, SaltBrand> => {
    try {
      return !!n && n.length === saltLength * 2 && Buffer.from(n, "hex").length === saltLength;
    } catch {
      return false;
    }
  },
  "Salt"
);
export type Salt = t.TypeOf<typeof Salt>;
export type SaltOutput = typeof Salt._O;

export function newSalt(): Salt {
  const saltDecoded = Salt.decode(crypto.randomBytes(saltLength).toString("hex"));
  if (saltDecoded._tag === "Left") {
    console.error("Creating salt failed", PrettyPrintIoTsErrors(saltDecoded.left));
    throw new Error("Creating salt failed");
  }

  return saltDecoded.right;
}

export function saltToBuffer(salt: Salt): Buffer {
  return Buffer.from(Salt.encode(salt), "hex");
}
